<template>
  <div>
    <ld-header
      :left-arrow="false"
      :right-text="$t('C121','筛选')"
      @click-right="toggle('filterPanel')"
    >
      {{ $t('K126','出差申请单') }}
    </ld-header>

    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        @init="mescrollInit"
        :up="mescrollUp"
      >
        <div class="list-view">
          <div
            class="list-view__card bg-white"
            v-for="(applyItem, index) in applyList"
            :key="index"
            @click.stop="$router.push({path: '/tripDetail', query: {ccsqdId: applyItem.ccsqdId }})"
          >
            <van-cell :border="true">
              <van-row>
                <van-col
                  span="16"
                  class="van-ellipsis deep-gray"
                >
                  <ld-icon
                    class="main-color"
                    type="iconweibiaoti-28"
                  />

                  {{ applyItem.ccsqdNo }}
                  <!-- <span v-show="applyItem.mdd != '---'">{{ applyItem.mdd }}</span> -->
                </van-col>
                <van-col span="8">
                  <div
                    class="text-right"
                    :class="['', 'light-green', 'main-color', 'red', 'light-green', 'main-color'][applyItem.status]"
                  >
                    {{ applyItem.status | tripStatus }}
                  </div>
                </van-col>
              </van-row>
            </van-cell>
            <van-cell>
              <van-row>
                <van-col span="4">
                  {{ $t('F031','时间') }}:
                </van-col>
                <!-- <van-col span="20">
                  {{ applyItem.dateBegin }}&nbsp;&nbsp;{{ applyItem.dateEnd }} -->
                <van-col span="20" style="text-align: right;">
                  <span>
                    {{ applyItem.dateBegin }}
                    <span v-show="applyItem.dateEnd">&nbsp;&nbsp;{{ applyItem.dateEnd }}</span>
                  </span>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="8">
                  行程:
                </van-col>
                <van-col span="16" style="text-align: right;">
                  <span v-if="applyItem.mdd">
                    {{ applyItem.mdd }}
                  </span>
                  <span v-else-if="applyItem.travelTrip">
                    {{ applyItem.travelTrip }}
                  </span>
                </van-col>
              </van-row>
              <van-row v-show="applyItem.zys > 0">
                <van-col span="4">
                  {{ $t('E027','预算') }}:
                </van-col>
                <van-col span="20" style="text-align: right;">
                  &yen;{{ applyItem.zys | filterMoney }}
                </van-col>
              </van-row>
              <van-row>
                <van-col span="4">
                  {{ $t('K130','出差人') }}:
                </van-col>
                <van-col span="20" style="text-align: right;">
                  {{ applyItem.ccrAndSxr }}
                </van-col>
              </van-row>
              <van-row>
                <van-col span="4">
                  {{ $t('K102','事由') }}:
                </van-col>
                <van-col span="20" style="text-align: right;">
                  {{ applyItem.ccsy }}
                </van-col>
              </van-row>
            </van-cell>

            <van-cell v-show="applyItem.status == 0">
              <van-row
                gutter="8"
              >
                <van-col span="12" />
                <van-col span="6">
                  <ld-button
                    main
                    size="sm"
                    @click.stop="editTrip(applyItem.ccsqdId)"
                  >
                    {{ $t('B053','编辑') }}
                  </ld-button>
                </van-col>
                <van-col span="6">
                  <ld-button
                    defaults
                    size="sm"
                    @click.stop="deletTrip(applyItem.ccsqdId)"
                  >
                    {{ $t('B052','删除') }}
                  </ld-button>
                </van-col>
              </van-row>
            </van-cell>
              
            <van-cell v-show="applyItem.status == 1">
              <van-row
                gutter="8"
              >
                <van-col span="18" />
                <van-col span="6">
                  <ld-button
                    defaults
                    size="sm"
                    @click.stop="revertApproval(applyItem)"
                  >
                    {{ $t('B065','撤回') }}
                  </ld-button>
                </van-col>
              </van-row>
            </van-cell>
          </div>
          <!--  -->
          <ld-no-more />
          <!--  -->
        </div>
      </mescroll-vue>
    </div>
    
    <div
      class="newApply bg-main"
      @click.stop="$router.push({path:'/tripAdd'})"
    >
      {{ $t('K125','新增') }}
    </div>

    <!-- 筛选 -->
    <filter-panel
      ref="filterPanel"
      @selected="getList"
    />
  </div>
</template>

<script>
import { formatDate } from 'Utils/dateUtil'
import MescrollVue from 'mescroll.js/mescroll.vue'
import filterPanel from './components/filterPanel'
import { mapGetters } from 'vuex'
import ldButton from 'Common/ldButton'
import { Cell,PullRefresh  } from 'vant'
import ldNoMore from 'Common/ldNoMore'
import Business from '@/business/utils/business'

export default {
  name: 'TripList',
  components:{
    MescrollVue,
    filterPanel,
    ldButton,
    [Cell.name]:Cell,
    [PullRefresh.name]:PullRefresh,
    ldNoMore
  },
  data: function() {
    return {
      applyList: [],
      pageNum: 1,
      count: 10,
      // 其他过滤条件
      status: '',
      dateType: '1', //(1申请日期2出差日期)
      ccr: '',
      dateBegin: formatDate(new Date().setFullYear(new Date().getFullYear() - 4)).date,
      dateEnd: formatDate(new Date()).date,
      filterShow: false, //筛选
      mescrollUp: { use: true, callback: this.onRefresh, htmlNodata: '' }
    }
  },
  computed: {
    ...mapGetters({
      tripType: 'tripType',
      userInfo:'userInfo'
    })
  },
  filters: {
    tripStatus: function(val) {//过滤器判断订单状态
      let obj=['草稿','审批中','审批通过','审批拒绝','报销中','已报销']
      return obj[val]
    },
    filterMoney:function(val){
      if(Number(val)>100000){
        return Number(val)/10000 + '万'
      }else{
        return val
      }
    },
  },
  created(){
    this.$store.commit('tk/CLEAR_ALL',{})
    this.$store.commit('tkInt/CLEAR_ALL',{})
    this.$store.commit('ht/CLEAR_ALL',{})
    this.$store.commit('tr/CLEAR_TRSEARCHINFO',{})
    this.$store.commit('trip/CLEAR_ALL',{})//清除新增申请单缓存
    this.$store.commit('trip/CLEAR_PARAMS',{})
  },
  methods: {
    toggle(name){
      this.$refs[name].toggle()
    },
    mescrollInit (mescroll) {
      this.mescroll = mescroll  // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    onRefresh(page) {
      this.pageNum = page.num
      this.getList()
    },
    //获取接口，设置函数回调
    async getList(params) {
      try {
        if (params) { // 筛选回调
          this.pageNum = 1
          Object.assign(this, params)
        }

        var queryString = {
          count: 20, //每页条数
          pageNum: this.pageNum,
          status: this.status,
          dateType: this.dateType,
          dateBegin: this.dateBegin,
          dateEnd: this.dateEnd,
          ccr: this.ccr,
        }

        const { data = {} } = await this.$api['common/vipCcsqdGetList'](queryString)
        
        let list = data.list || []

        if (list.length) {
          if (data.pageNum > 1) {
            this.applyList.push(...list)
          } else if (data.pageNum == 1) {
            this.applyList = list
          }
        }else{
          // this.applyList = []
        }

        this.$nextTick(() => {
          this.mescroll.endSuccess(list.length, data.total)
        })

      } catch (error) {
        this.mescroll && this.mescroll.endErr()
        throw error
      }
    },
    editTrip(ccsqdId){
      this.$store.commit('trip/params',{ ccsqdId: ccsqdId })
      this.$router.push({path:'/tripAdd'})
    },
    //删除操作
    deletTrip(id) {
      let self = this
      this.$dialog.confirm({
        title: this.$t('C474','提示'),
        message: '您确定要删除草稿吗？'
      }).then(() => {
        self.$api['common/vipCcsqdDel']({ccsqdId: id}).then(() => {
          self.$toast('已删除')
          this.getList()
        })
      }).catch(() => {
        // on cancel
      })
    },
    async revertApproval (item) {
      await Business.ApprovalRevert({
        orderId: item.ccsqdId,
        orderType: '11099'
      })
      this.getList()
    }
  },

}
</script>
<style lang="less" scoped>
.m-b-5 {
  margin-bottom: 5px;
}
.wrapper {
  height: calc(100vh - 96px);
  overflow: hidden;
}

.newApply {
  height: 40px;
  width: 40px;
  line-height: 40px;
  text-align: center;
  font-size: @font-size-12;
  border-radius: 40px;
  color: @color-text-white;
  position: fixed;
  bottom: 84px;
  right: 12px;
  border: 1px solid @color-text-white;
}
</style>
